import React from "react";
import PropTypes from "prop-types";
import "./FeatureCard.css";

const FeatureCardCom = ({ icon, title, content }) => {
  return (
    <div className="feature-card">
      <div className="feature-header">
        <img src={icon} alt="Icon" className="feature-icon" />
        <h3 className="feature-title">{title}</h3>
      </div>
      <div className="feature-content">{content}</div>
    </div>
  );
};

FeatureCardCom.propTypes = {
  icon: PropTypes.string.isRequired, // 图标 URL
  title: PropTypes.string.isRequired, // 标题文本
  content: PropTypes.node.isRequired, // 内容，支持带格式的 HTML
};

export default FeatureCardCom;
